function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonGroup, Flex, Icon, IconButton, Popover, PopoverBody, PopoverContent, PopoverTrigger, Slider, SliderFilledTrack, SliderThumb, SliderTrack, Stack, Tooltip, useToken } from '@chakra-ui/react';
import { faVolumeMute, faVolumeLow, faVolumeHigh, faForwardStep, faBackwardStep, faHeart } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PlayIcon from '../PlayIcon';
import { motion, useAnimationControls } from 'framer-motion';
import { faHeartOutline } from '../icons/fontawesome/HeartOutline';
import useIntlMemo from '@/hooks/useIntlMemo';
function VolumeSlider(_param) {
    var onVolume = _param.onVolume, value = _param.value, props = _object_without_properties(_param, [
        "onVolume",
        "value"
    ]);
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(Slider, _object_spread_props(_object_spread({
        min: 0,
        max: 100,
        colorScheme: "primary",
        "aria-label": intl.formatMessage({
            id: "y867Vs",
            defaultMessage: [
                {
                    type: 0,
                    value: "Volume"
                }
            ]
        }),
        maxWidth: 100,
        value: value * 100,
        onChange: function(value) {
            return onVolume === null || onVolume === void 0 ? void 0 : onVolume(value / 100);
        }
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(SliderTrack, {
                children: /*#__PURE__*/ _jsx(SliderFilledTrack, {})
            }),
            /*#__PURE__*/ _jsx(SliderThumb, {})
        ]
    }));
}
function SongControls(_param) {
    var _param_isPlaying = _param.isPlaying, isPlaying = _param_isPlaying === void 0 ? false : _param_isPlaying, _param_isRepeated = _param.isRepeated, isRepeated = _param_isRepeated === void 0 ? true : _param_isRepeated, _param_isShuffled = _param.isShuffled, isShuffled = _param_isShuffled === void 0 ? false : _param_isShuffled, _param_isMuted = _param.isMuted, isMuted = _param_isMuted === void 0 ? false : _param_isMuted, _param_hasHistory = _param.hasHistory, hasHistory = _param_hasHistory === void 0 ? false : _param_hasHistory, _param_hasMore = _param.hasMore, hasMore = _param_hasMore === void 0 ? false : _param_hasMore, _param_volume = _param.volume, volume = _param_volume === void 0 ? 0 : _param_volume, initialPlayerPosition = _param.playerPosition, playerDuration = _param.playerDuration, currentSong = _param.currentSong, _param_isBuffering = _param.isBuffering, isBuffering = _param_isBuffering === void 0 ? false : _param_isBuffering, _param_inPlaylist = _param.inPlaylist, inPlaylist = _param_inPlaylist === void 0 ? false : _param_inPlaylist, _param_loadingInPlaylist = _param.loadingInPlaylist, loadingInPlaylist = _param_loadingInPlaylist === void 0 ? false : _param_loadingInPlaylist, onToggleInPlaylist = _param.onToggleInPlaylist, onSeek = _param.onSeek, onPlayToggle = _param.onPlayToggle, onMuteToggle = _param.onMuteToggle, onNextSong = _param.onNextSong, onLastSong = _param.onLastSong, onShuffle = _param.onShuffle, onVolume = _param.onVolume, onRepeat = _param.onRepeat, onClearQueue = _param.onClearQueue, onEditSettings = _param.onEditSettings, onImportPlaylist = _param.onImportPlaylist, onClearPlaylist = _param.onClearPlaylist, props = _object_without_properties(_param, [
        "isPlaying",
        "isRepeated",
        "isShuffled",
        "isMuted",
        "hasHistory",
        "hasMore",
        "volume",
        "playerPosition",
        "playerDuration",
        "currentSong",
        "isBuffering",
        "inPlaylist",
        "loadingInPlaylist",
        "onToggleInPlaylist",
        "onSeek",
        "onPlayToggle",
        "onMuteToggle",
        "onNextSong",
        "onLastSong",
        "onShuffle",
        "onVolume",
        "onRepeat",
        "onClearQueue",
        "onEditSettings",
        "onImportPlaylist",
        "onClearPlaylist"
    ]);
    var intl = useIntl();
    var controls = useAnimationControls();
    var _useToken = _sliced_to_array(useToken('colors', [
        'primary.500',
        'primary.200'
    ]), 2), lightPrimaryColor = _useToken[0], darkPrimaryColor = _useToken[1];
    var volumeIcon = React.useMemo(function() {
        if (volume === 0) {
            return faVolumeMute;
        } else if (volume <= 0.5) {
            return faVolumeLow;
        } else {
            return faVolumeHigh;
        }
    }, [
        volume
    ]);
    React.useEffect(function() {
        if (playerDuration == null || initialPlayerPosition == null || currentSong == null) {
            controls.stop();
            controls.set({
                width: '0%'
            });
            return;
        }
        var durationLeft = playerDuration - initialPlayerPosition;
        var progressPercent = initialPlayerPosition / playerDuration;
        if (!isPlaying || isBuffering) {
            controls.stop();
            return;
        }
        controls.start({
            width: [
                "".concat(progressPercent * 100, "%"),
                '100%'
            ],
            transition: {
                duration: durationLeft,
                ease: 'linear'
            }
        });
    }, [
        playerDuration,
        initialPlayerPosition,
        isPlaying,
        controls,
        currentSong,
        isBuffering
    ]);
    function handleOnSeek(event) {
        if (playerDuration == null || currentSong == null) {
            return;
        }
        var rect = event.currentTarget.getBoundingClientRect();
        var positionPercentage = (event.clientX - rect.left) / rect.width;
        var position = positionPercentage * playerDuration;
        onSeek === null || onSeek === void 0 ? void 0 : onSeek(position);
    }
    var addToPlaylistLabel = useIntlMemo(function(intl) {
        return inPlaylist ? intl.formatMessage({
            id: "fw9Ogq",
            defaultMessage: [
                {
                    type: 0,
                    value: "Remove from Playlist"
                }
            ]
        }) : intl.formatMessage({
            id: "JunmfI",
            defaultMessage: [
                {
                    type: 0,
                    value: "Add to Playlist"
                }
            ]
        });
    }, [
        inPlaylist
    ]);
    return /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
        gap: 0
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                width: "100%",
                backgroundColor: "borderSecondary",
                height: 1,
                onClick: handleOnSeek,
                cursor: "pointer",
                children: /*#__PURE__*/ _jsx(Box, {
                    as: motion.div,
                    animate: controls,
                    style: {
                        height: '100%',
                        backgroundColor: "light-dark(".concat(lightPrimaryColor, ", ").concat(darkPrimaryColor, ")")
                    }
                }, "progress")
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                padding: 4,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        gap: 4,
                        flex: 1,
                        display: {
                            base: 'none',
                            md: 'flex'
                        },
                        children: [
                            /*#__PURE__*/ _jsx(IconButton, {
                                variant: "ghost",
                                size: "sm",
                                "aria-label": isMuted ? intl.formatMessage({
                                    id: "W9355R",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Unmute"
                                        }
                                    ]
                                }) : intl.formatMessage({
                                    id: "x82IOl",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Mute"
                                        }
                                    ]
                                }),
                                icon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: volumeIcon
                                }),
                                onClick: function() {
                                    return onMuteToggle === null || onMuteToggle === void 0 ? void 0 : onMuteToggle();
                                }
                            }),
                            /*#__PURE__*/ _jsx(VolumeSlider, {
                                value: volume,
                                onVolume: onVolume
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        flex: 1,
                        display: {
                            base: 'block',
                            md: 'none'
                        },
                        children: /*#__PURE__*/ _jsxs(Popover, {
                            placement: "top-start",
                            children: [
                                /*#__PURE__*/ _jsx(PopoverTrigger, {
                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                        variant: "unstyled",
                                        "aria-label": intl.formatMessage({
                                            id: "XbMpEq",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Volume Popover"
                                                }
                                            ]
                                        }),
                                        icon: /*#__PURE__*/ _jsx(Icon, {
                                            as: FontAwesomeIcon,
                                            icon: volumeIcon
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(PopoverContent, {
                                    width: "fit-content",
                                    backgroundColor: "backgroundPrimary",
                                    paddingTop: 2,
                                    children: /*#__PURE__*/ _jsx(PopoverBody, {
                                        children: /*#__PURE__*/ _jsx(VolumeSlider, {
                                            value: volume,
                                            onChange: onVolume,
                                            orientation: "vertical",
                                            height: "100px"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(ButtonGroup, {
                        alignItems: "center",
                        flex: 1,
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ _jsx(IconButton, {
                                variant: "unstyled",
                                isDisabled: !hasHistory,
                                "aria-label": intl.formatMessage({
                                    id: "8heESb",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Last Song"
                                        }
                                    ]
                                }),
                                icon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: faBackwardStep
                                }),
                                onClick: function() {
                                    return onLastSong === null || onLastSong === void 0 ? void 0 : onLastSong();
                                }
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                variant: "cta",
                                borderRadius: "full",
                                size: "sm",
                                _active: {
                                    transform: 'scale(0.85)'
                                },
                                isDisabled: currentSong == null,
                                "aria-label": isPlaying ? intl.formatMessage({
                                    id: "tFFMkF",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Pause"
                                        }
                                    ]
                                }) : intl.formatMessage({
                                    id: "J3ca41",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Play"
                                        }
                                    ]
                                }),
                                icon: /*#__PURE__*/ _jsx(PlayIcon, {
                                    enabled: isPlaying
                                }),
                                onClick: function() {
                                    return onPlayToggle === null || onPlayToggle === void 0 ? void 0 : onPlayToggle();
                                }
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                variant: "unstyled",
                                isDisabled: !hasMore && currentSong == null,
                                "aria-label": intl.formatMessage({
                                    id: "UcSVVY",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Next Song"
                                        }
                                    ]
                                }),
                                icon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: faForwardStep
                                }),
                                onClick: function() {
                                    return onNextSong === null || onNextSong === void 0 ? void 0 : onNextSong();
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        flex: 1,
                        justifyContent: "flex-end",
                        children: /*#__PURE__*/ _jsx(Tooltip, {
                            label: addToPlaylistLabel,
                            hasArrow: true,
                            children: /*#__PURE__*/ _jsx(IconButton, {
                                "aria-label": addToPlaylistLabel,
                                onClick: function() {
                                    return onToggleInPlaylist();
                                },
                                isLoading: loadingInPlaylist,
                                icon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: inPlaylist ? faHeart : faHeartOutline
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
}
export default SongControls;
